import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {OptionalCustomerSession} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/session.types';
import {ArticleDetailService_GetProductDetailsBulkLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.grpc.lazy';
import {Log} from '@aboutyou/mlm';

const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

// Product details data is session-independent, so we hardcode the request
// parameters. This avoids depending on user/session/basket hooks that are not
// available in the app-checkout webview bundle.
const NO_SESSION: OptionalCustomerSession = {
  type: {$case: 'noSession', noSession: {}},
};
const EMPTY_REDUCTIONS_STATE = {};

export const useCheckoutProductDetails = (
  productId: number,
  enabled: boolean,
) => {
  return useGrpcRequest(
    ArticleDetailService_GetProductDetailsBulkLazy,
    {
      productId,
      session: NO_SESSION,
      reductionsState: EMPTY_REDUCTIONS_STATE,
      withBasicProductInfoOnly: true,
    },
    {
      disabled: !enabled || !productId,
      section: 'productDetailsSection',
      staleTime: FIVE_MINUTES_IN_MS,
      refetchOnWindowFocus: false,
      onError: error => {
        Log.unSampledLog('GetCheckoutProductDetails', {
          productId,
          status: 'error',
          response: error,
        });
      },
    },
  );
};
